import {Component, Input, OnInit} from '@angular/core';
import {ErrorLogModel} from '../../models/error-log.model';
import {ModalController} from '@ionic/angular';

@Component({
    selector: 'app-error-log',
    templateUrl: './error-log.page.html',
    styleUrls: ['./error-log.page.scss'],
})
export class ErrorLogPage implements OnInit {
    @Input() errorsLogged: ErrorLogModel[];

    constructor(public modalController: ModalController) {
    }

    ngOnInit() {
    }

    emailError(err: ErrorLogModel) {
        console.log(err);
    }
}
